export interface Args {
  projectId: string;
  propertyId?: string;
}

export interface PropertyRow {
  id: string;
  name: string | null;
  address: string | null;
  city: string | null;
  state: string | null;
  store_number: string | null;
}

export interface AssetRow {
  id: string;
  property_id: string;
  name: string | null;
  description: string | null;
  asset_categories: { name: string } | { name: string }[] | null;
  manufacturer: string | null;
  model_name: string | null;
  model_number: string | null;
  serial_number: string | null;
  manufacture_date: string | null;
  estimated_age_years: number | null;
  condition_status: string | null;
  category_attributes: Record<string, unknown> | null;
  notes: string | null;
  project_zones: { name: string } | { name: string }[] | null;
  nameplate_photo_url: string | null;
  asset_photo_url: string | null;
}

export interface AttributeRow {
  property_id: string;
  data: unknown;
  captured_at: string | null;
}

export interface AssetNoteRow {
  asset_id: string;
  note_text: string;
  created_at: string;
}

export interface DeficiencySourceRow {
  property_id: string;
  data: unknown;
}

export interface DeficiencyPayload {
  deficiencies?: unknown[];
}

export interface SiteSummaryDocumentRow {
  property_id: string | null;
  document_name: string;
  file_path: string | null;
  created_at: string;
}

export const PROPERTY_BATCH = 40;
export const PAGE_SIZE = 1000;
export const REPORT_DOWNLOAD_CONCURRENCY = 6;
